module.exports = __webpack_public_path__ + "img/1067.42cce844.svg";